module.exports = __webpack_public_path__ + "static/mr-press-09-142bbbce51aa9ddf1275b1f2b94312ab.jpg";